import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MessengerService, IInbox } from '../shared/messenger.service'; 
import { Router } from '@angular/router';

@Component({
  selector: 'app-messenger',
  templateUrl: './messenger.component.html',
  styleUrls: ['./messenger.component.scss']
})
export class MessengerComponent implements OnInit {
  @ViewChild('chat') chat: ElementRef; 
  public inbox: IInbox = null;

  constructor(
    public messenger_service: MessengerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.messenger_service.ready.subscribe(value => {
      if (value) {
        if (this.messenger_service.inboxes[0]) {
          this.inbox = this.messenger_service.inboxes[0];
          this.inbox.session.createInbox({useBrowserHistory: false}).mount(this.chat.nativeElement);
        } else {
          this.router.navigate(['/']);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/messenger/messenger.component.ts